exports = module.exports = require("../../../../../../legacy/web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".classificationMainView{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column}._3iX_x4SMnW1GFPpx27GyKe{margin-top:1rem;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column}._1djTj1sBtVAJP2mdIZgNE0{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between}._1djTj1sBtVAJP2mdIZgNE0>div{width:calc(50% - .5rem)}\n", ""]);

// exports
exports.locals = {
	"classificationTypes": "_3iX_x4SMnW1GFPpx27GyKe",
	"childDestination": "_1djTj1sBtVAJP2mdIZgNE0"
};